import React from "react";
import ContactItem from "../Components/ContactItem";
import email from "../Assets/emailme.svg";
import phone from "../Assets/phone.svg";
import location from "../Assets/location.svg";
import Tittle from "../Components/Tittle";

function ContactPage() {
  return (
    <div>
      <div className="title">
        <Tittle title={"Contact Me"} span={"Contact Me"} />
      </div>
      <div className="ContactPage">
        <div className="map-sect">
          <iframe
            // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2519.700327595181!2d-0.13858868403737226!3d50.836714467337785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487585104ec1fe1b%3A0x28b5349b15ce0c4d!2sLondon%20Road%20(Brighton)%20Train%20Station%20-%20Southern%20Railway!5e0!3m2!1sen!2suk!4v1611468671158!5m2!1sen!2suk"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6009069.56808649!2d-80.25903546643882!3d42.658897159555785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York!5e0!3m2!1sen!2sus!4v1627454958441!5m2!1sen!2sus"
            width="600"
            height="450"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
        <div className="contact-sect">
          <ContactItem
            icon={phone}
            // text1={"+1 (585)-363-9186"}
            text1={"Email me for the no.😛"}
            // text2={"+0333 6782 8792"}
            title={"Phone"}
          />
          <ContactItem
            icon={email}
            text1={"DB3765[at]rit[dot]edu"}
            // text2={"delzadbamji[at]gmail[dot]com"}
            title={"Email"}
          />
          <ContactItem
            icon={location}
            text1={"New York"}
            text2={"United States"}
            title={"Address"}
          />
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
